module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "load-overlay",
    class: {
      loaded: _vm.load
    }
  }), _vm._v(" "), _c('sidebar', {
    on: {
      "menu": function($event) {
        _vm.togglePanel()
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('images', {
    class: {
      menuOpen: _vm.menu
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header--main"
  }, [_c('h2', [_c('b', [_vm._v("Free Photos")]), _vm._v(" by "), _c('a', {
    attrs: {
      "href": "https://thefrontend.uk",
      "target": "_blank"
    }
  }, [_vm._v("Alex Shepherd")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./assets/cc.svg"),
      "alt": "Creative Commons",
      "width": "32px",
      "height": "32px"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./assets/by.svg"),
      "alt": "Creative Commons",
      "width": "32px",
      "height": "32px"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fb3ccd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 44
// module chunks = 1